import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Form } from 'react-final-form';
import AccountantForm from 'router/pages/Accountant/component/AccountantForm/AccountantForm.component';
import arrayMutators from 'final-form-arrays';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowleftIcon from 'icons/Arrowleft.icon';
import { PROFILE_ROUTE } from 'data/global';

import './InvestorVerificationPreview.styles.scss';
import './InvestorVerificationPreview.styles.responsive.scss';

type InvestorVerificationPreviewProps = {
  className?: string;
};

const InvestorVerificationPreview: React.FC<
  InvestorVerificationPreviewProps
> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const initialValues = useMemo(() => {
    return {
      createAccountOnResolve: true,
      directorshipACN: [''],
      recipientDetails: [
        {
          firstName: '',
          email: '',
          customNote: '',
        },
      ],
    };
  }, []);

  const classes = classNames('investor-verification-preview', className);

  return (
    <div className={classes}>
      <Link to={PROFILE_ROUTE}>
        <ArrowleftIcon />
        {t('backToProfile')}
      </Link>
      <p>{t('previewFormWarning')}</p>
      <Form
        initialValues={initialValues}
        mutators={{ ...arrayMutators }}
        onSubmit={() => {}}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <AccountantForm />
          </form>
        )}
      />
    </div>
  );
};

export default InvestorVerificationPreview;
